import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { PageAccessLogDTO } from '../../model/access-log.model';

export interface AccessLogQuery {
  page: number;
  size: number;
  sort?: string[];
  userId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccessLogAdminService {
  private readonly baseUrl = `${environment.apiBaseAdminUrl}/access-logs`;

  constructor(private http: HttpClient) {}

  getAccessLogs(query: AccessLogQuery): Observable<PageAccessLogDTO> {
    let params = new HttpParams().set('page', query.page).set('size', query.size);

    if (query.sort?.length) {
      query.sort.forEach(s => {
        params = params.append('sort', s);
      });
    }

    if (query.userId) {
      params = params.set('user_id', query.userId);
    }

    return this.http.get<PageAccessLogDTO>(this.baseUrl, { params });
  }
}
